import { lazy, useEffect, useState } from 'react';

const FeedbackTabContent = lazy(() => import('./FeedbackTabContent'));

export default function FeedbackTab({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 1000 * 25);

  }, [])


  if (!ready) {
    return null
  }

  return (
    <FeedbackTabContent>
      {children}
    </FeedbackTabContent>
  )
}
